module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrRoman.04d2a58.woff";